import dayjs from "dayjs";
export const getOption = (
  data: Array<{ day: string; usedCredit: number }>,
  color: string,
  curClass: { label: string; value: string },
) => {
  const days = [];
  const usedCredits = [];
  let totalCredit = 0;
  data.forEach((item) => {
    days.push(dayjs(item.day).format("MMM D"));
    usedCredits.push(item.usedCredit);
    totalCredit += item.usedCredit;
  });
  return {
    title: {
      text: curClass.label + " Credit Usage",
    },
    grid: {
      left: 0,
      right: 40,
      bottom: "40px",
    },
    xAxis: {
      type: "category",
      data: days,
      axisTick: { show: false },
      axisLabel: { interval: days.length - 2 },
    },
    yAxis: {
      type: "value",
      name: totalCredit,
      nameTextStyle: {
        fontWeight: 600,
        fontSize: 16,
        color: "black",
        padding: [0, 0, 24, 0],
      },
      position: "right",
    },
    tooltip: {
      trigger: "axis",
    },
    series: [
      {
        name: "Used Credit",
        itemStyle: { color },
        data: usedCredits,
        type: "bar",
      },
    ],
  };
};
